
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    activityDailyCheckactivityDailyCheckData
  } from "@/api/live"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private level = null
    private levellist = [
      {
        label: '全部',
        value: null
      }, {
        label: 'SVIC',
        value: 1
      },{
        label: 'VIC',
        value: 2
      },{
        label: 'VIP',
        value: 3
      },{
      	label: '客户',
      	value: 0
      }
    ]
    private state = null
    private statelist = [
      {value:null,label:'全部'},
      {value:1,label:'未使用'},
      {value:0,label:'已使用'},
      {value:2,label:'已过期'},
    ]
    private tablelist:any = []
    private tableloading = false
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
    private result:any = {}




    private mounted () {
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.state = null
      this.level = null
      this.doSearch()
    }
    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await activityDailyCheckactivityDailyCheckData({
          Id:this.$route.query.Id,
          Keywords:this.keywords,
          RoleGrade:this.level,
          State:this.state,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
          this.result = res.Result
        }
      }finally{
        this.tableloading = false
      }
    }
    private exportfile(){
      let url = location.origin + '/pc/activityDailyCheck/activityDailyCheckDataExport'
      url += '?Id=' + this.$route.query.Id
      url += '&Keywords=' + encodeURIComponent(this.keywords)
      url += '&RoleGrade=' + (this.level==null?'':this.level)
      url += '&State=' + (this.state==null?'':this.state)
      window.open(url)
    }
  }
